import * as React from 'react';
import { Header } from '../';
import ComponentListContainer from '../../containers/component-list';
import SidebarContainer from '../../containers/sidebar';
import SettingsContainer from '../../containers/settings';
import ToolsContainer from '../../containers/tools';
import ModalContainer from '../../containers/modal';
import ErrorDisplayContainer from '../../containers/error-display';
import ConfirmationDialogContainer from '../../containers/confirmation-dialog';

export class Home extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
  }

  public render() {

    let pinClass: string = this.props.sidebarPinned ? '-sidebar-pinned' : '';

    let welcome: JSX.Element =
      <div className={pinClass} id="container">
        <Header />
        <ToolsContainer />
        <ErrorDisplayContainer />
        <div className="pos-r">
          <ComponentListContainer branchId='root' />
          <ModalContainer />
          <ConfirmationDialogContainer />
          <SidebarContainer />
          <SettingsContainer />
        </div>
      </div>;

    return (welcome);

  }

}


// WEBPACK FOOTER //
// ./source/ts/components/layout/home.tsx